let BASEURL = process.env.VUE_APP_BASEURL;

if (window.location.hostname !== "localhost") {
    BASEURL = "";
}

let setBaseurl = function(baseurl) {
    if (baseurl === "") {
        baseurl = "www";
    }
    BASEURL = "https://" + baseurl + ".klickmal.at";
};

export { BASEURL, setBaseurl };
